import React from 'react';
import {useNavigate} from "react-router-dom";

import KeyValueHorizontal from "../../components/KeyValueHorizontal";
import Page from "../../layouts/Main/Page";
import SummaryCard, {SummaryCardStack, SummaryCardActions} from "./SummaryCard";
import RequestsCard from "./RequestsCard";
import {useSummaryQuery} from "./query";

import Grid from "@mui/material/Grid";
import OffersIcon from '@mui/icons-material/LocalOffer';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import lime from "@mui/material/colors/lime";
import green from "@mui/material/colors/green";
import Button from "@mui/material/Button";
import BookingsCard from "./BookingsCard";


const Dashboard = () => {
    const summaryQuery = useSummaryQuery();
    const summary = summaryQuery.data;

    // Set is loading only when the data is undefined, meaning the query
    // has never been executed yet. Do not ues summaryQuery.isLoading because
    // the Page unmount the content when the query is loading and shows the
    // circular progress. Not that it expect the query to keep the previous data
    // TODO refactor the page and handle the loading state individually for each card
    const isLoading = summaryQuery.data === undefined && summaryQuery.isLoading;

    let navigate = useNavigate();

    const bookingsSummary = summary ? summary["bookings"] : {};

    const activeFilters = summary ? summary["filters"]["active"] : 0;

    const activeOffers = summary ? summary["offers"]["active"] : 0;

    const requestsSummary = summary ? summary["requests"] : {};

    const handleFilterSelection = () => {
        navigate("/main/filter_rules");
    };

    const handleOfferSelection = () => {
        navigate("/main/offers");
    };

    return (
        <Page title="Dashboard" loading={isLoading}>
            <Grid container spacing={3}>

                <Grid item xs={12} lg={4}>
                    <BookingsCard bookingsSummary={bookingsSummary}/>
                </Grid>

                <Grid item xs={12} lg={4}>
                    <RequestsCard requestsSummary={requestsSummary}/>
                </Grid>

                <Grid item xs={12} lg={4}>
                    <SummaryCard title="Filtri"
                                 avatarColor={lime[600]}
                                 AvatarIcon={PlaylistAddCheckIcon}>
                        <SummaryCardStack>
                            <KeyValueHorizontal valueTextVariant="h4"
                                                keyTextVariant="body2"
                                                showKeyOnBottom={true}
                                                keyPadding={0}
                                                pairs={[
                                                    ["Filtri attivi", activeFilters],
                                                ]}
                            />
                        </SummaryCardStack>

                        <SummaryCardActions>
                            <Button size="small" onClick={handleFilterSelection}>{"Gestisci"}</Button>
                        </SummaryCardActions>
                    </SummaryCard>
                </Grid>

                <Grid item xs={12} lg={4}>
                    <SummaryCard title="Offerte"
                                 avatarColor={green[600]}
                                 AvatarIcon={OffersIcon}>

                        <SummaryCardStack size="small">
                            <KeyValueHorizontal valueTextVariant="h4"
                                                keyTextVariant="body2"
                                                showKeyOnBottom={true}
                                                keyPadding={0}
                                                pairs={[
                                                    ["Offerte attive", activeOffers],
                                                ]}
                            />
                        </SummaryCardStack>

                        <SummaryCardActions>
                            <Button size="small" onClick={handleOfferSelection}>{"Gestisci"}</Button>
                        </SummaryCardActions>
                    </SummaryCard>
                </Grid>
            </Grid>
        </Page>
    );
};

export default Dashboard;